import { useEffect, useState } from "react"
import { getSession, setAdminHint } from "../lib/adminApi.js"

// Asks the server whether the browser holds a valid admin session.
// Returns "checking", "authenticated" or "anonymous".
export default function useAdminSession() {
  const [status, setStatus] = useState("checking")

  useEffect(() => {
    let active = true
    getSession()
      .then((ok) => active && setStatus(ok ? "authenticated" : "anonymous"))
      .catch(() => {
        setAdminHint(false) // no confirmed session: hide admin links
        if (active) setStatus("anonymous")
      })
    return () => {
      active = false
    }
  }, [])

  return status
}
